import { Dayjs } from "dayjs";
import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_DATE_TIME_PICKER_MODE = {
  Date: "date",
  Time: "time",
} as const;

export type DSDateTimePickerMode = ObjectValues<typeof DS_DATE_TIME_PICKER_MODE>;

export type DSDateTimePickerModelValue = Dayjs | null;
